import * as React from 'react';
import scopus from "../../../assets/img/scopus.png";
import thomson from "../../../assets/img/thomsonReuters.png";
import google from "../../../assets/img/googleScholar.png";
import sinta from "../../../assets/img/garuda.png";
function capitalizeWords(str = '') {
    return str
        .toString()
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

function formatPublication(item, state) {
    const normalizedState = state?.toString().toLowerCase();
    const origin = (value) => {
        if (value === 'SINTA') return <img src={sinta} alt="sinta" className='h-8 w-11 object-contain' />;
        if (value === 'SCOPUS') return <img src={scopus} alt="scopus" className='h-8 w-11 object-contain' />;
        if (value === 'WEB OF SCIENCE') return <img src={thomson} alt="web of science" className='h-8 w-11 object-contain' />;
        if (value === 'GOOGLE SCHOLAR') return <img src={google} alt="google scholar" className='h-8 w-11 object-contain' />;
        return value;
    }
    if (normalizedState === 'paten') {
        return (
            <>
                <strong>{item?.nama}</strong>
                <span>, {item?.tanggal}, </span>
                {item?.url ? (
                    <a href={item.url} target="_blank" rel="noreferrer" className="font-bold text-brand-green no-underline hover:underline">
                        {item?.nama_paten}
                    </a>
                ) : (
                    <span>{item?.nama_paten}</span>
                )}
                <span>, {item?.lembaga ? `${item.lembaga}, ` : ''}Vol. {item?.no_paten}.</span>
            </>
        );
    }

    return (
        <p className='flex flex-column'>
            {item?.detail_publikasi?.tautan ? (
                <a href={item?.detail_publikasi?.tautan} target="_blank" rel="noreferrer" className="font-bold text-brand-blue no-underline hover:underline">
                    {item?.judul}
                </a>
            ) : (
                <span>{item?.judul}</span>
            )}
            <span className='flex flex-row gap-3 mt-1'>
                <span className='outline outline-1 outline-offset-1 outline-cyan-500 text-cyan-500 px-2 text-[11px] rounded-full'>{origin(item?.asal_data)}</span>
                <span><i className='fa-regular fa-calendar'></i> {new Date(item?.tanggal).getFullYear()}</span>
                <span className='my-auto text-cyan-600'><i className='fa-solid fa-chart-pie'></i> {item?.quartile ? `Q-${item?.quartile}` : 'No-Q'}</span>
                <span className='my-auto text-brand-blue/50'> {item?.detail_publikasi?.nama_jurnal ? <> <i className='fa-solid fa-book-open'></i> {item?.detail_publikasi?.nama_jurnal}</> : ''}</span>
                {
                    item.penulis.length > 0 ? <span className='my-auto text-brand-blue/50'>Penulis: {item?.penulis?.map((author) => author.user.name).join(', ')}</span> : null
                }

            </span>

        </p>
    );
}

function Publikasi({ data = [], state }) {
    const [search, setSearch] = React.useState('');
    const [page, setPage] = React.useState(1);
    const limit = 10;
    const filteredData = React.useMemo(() => {
        const keyword = search.trim().toLowerCase();
        if (!keyword) {
            return data || [];
        }

        return (data || []).filter((item) => JSON.stringify(item).toLowerCase().includes(keyword));
    }, [data, search]);

    const totalPages = Math.max(1, Math.ceil(filteredData.length / limit));
    const currentPage = Math.min(page, totalPages);
    const visibleRows = filteredData.slice((currentPage - 1) * limit, currentPage * limit);

    React.useEffect(() => {
        setPage(1);
    }, [search, data]);

    return (
        <section className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
            <div className="rounded-lg border border-slate-200 bg-white p-5 shadow-soft">
                <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                    <div>
                        <span className="text-xs font-extrabold uppercase tracking-normal text-brand-green">Publikasi</span>
                        <h1 className="mt-2 font-display text-2xl font-extrabold text-brand-navy sm:text-3xl">
                            {capitalizeWords(state?.toString()?.replace(/_/g, ' '))}
                        </h1>
                    </div>
                    <label className="w-full sm:max-w-sm">
                        <span className="sr-only">Cari publikasi</span>
                        <input
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                            placeholder="Cari publikasi..."
                            className="h-11 w-full rounded-lg border border-slate-200 bg-white px-4 text-sm font-semibold outline-none transition focus:border-brand-green focus:ring-2 focus:ring-brand-green/20"
                        />
                    </label>
                </div>

                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-slate-200 text-left text-sm">
                        <thead className="bg-brand-navy text-xs font-extrabold uppercase tracking-normal text-white">
                            <tr>
                                <th className="w-16 px-4 py-4">No</th>
                                <th className="min-w-[520px] px-4 py-4">{capitalizeWords(state?.toString()?.replace(/_/g, ' '))}</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {visibleRows.length === 0 ? (
                                <tr>
                                    <td colSpan="2" className="px-4 py-10 text-center text-sm font-semibold text-slate-500">
                                        Data tidak ditemukan.
                                    </td>
                                </tr>
                            ) : null}

                            {visibleRows.map((item, index) => (
                                <tr key={`${item?.id || item?.judul || 'publikasi'}-${index}`} className="align-top transition hover:bg-slate-50">
                                    <td className="px-4 py-4 font-extrabold text-slate-500">{(currentPage - 1) * limit + index + 1}</td>
                                    <td className="px-4 py-4 leading-7 text-slate-700">{formatPublication(item, state)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="mt-5 flex flex-col gap-3 text-sm font-semibold text-slate-600 sm:flex-row sm:items-center sm:justify-between">
                    <span>
                        Menampilkan {visibleRows.length} dari {filteredData.length} data
                    </span>
                    <div className="flex items-center gap-2">
                        <button
                            type="button"
                            disabled={currentPage <= 1}
                            onClick={() => setPage((value) => Math.max(1, value - 1))}
                            className="rounded-lg border border-slate-200 px-3 py-2 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            Sebelumnya
                        </button>
                        <span className="px-2">Hal {currentPage}/{totalPages}</span>
                        <button
                            type="button"
                            disabled={currentPage >= totalPages}
                            onClick={() => setPage((value) => Math.min(totalPages, value + 1))}
                            className="rounded-lg border border-slate-200 px-3 py-2 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            Berikutnya
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Publikasi;
